<div class="p-3 w-100">
  <div class="row bgg-modal">
    <div class="col-md-6 col-12">
      <div class="d-flex flex-column">
        <label class="block text-900 font-medium mb-2 ms-label-view"><i class="pi pi-book mx-2"></i>{{'Days Before' |
          translator}}</label>
        <input type="text" [(ngModel)]="days" placeholder="placeholder" (ngModelChange)="updateDateLimits()" pInputText
          class="w-full mb-3 ms-border ms-input-view" />
      </div>
    </div>
    <div class="col-md-6 col-12 ppp-dropdown">
      <div class="d-flex flex-column">
        <label class="block text-900 font-medium mb-2 ms-label-view"><i class="pi pi-book mx-2"></i>{{"Reminder Date" |
          translator}}</label>
        <p-calendar class="v4-rtl-calander" appendTo="body" class="w-100" [(ngModel)]="date" dateFormat="dd-mm-yy"
          [minDate]="minDate" [maxDate]="maxDate" [readonlyInput]="false">
        </p-calendar>
      </div>
    </div>
    <div class="d-flex justify-content-center w-100 my-5">
      <button class="py-2 v4-btn-every" [disabled]="!days || !date" (click)="submit()"><i
          class="pi pi-check v4-ml-2"></i>{{"Submit" | translator}}</button>
    </div>
  </div>
</div>

<p-toast />